import App from '~/core/app';
import { collection, state, computed } from './state';
import actions from './actions';
import { ICore } from '~/core/core'; // type from the future
const core = App.Core<ICore>(); // grab sister controller

const events = App.Controller({
    name: 'alerts',
    state: {
        ...state,
        ...computed
    },
    collection,
    actions,
    events: App.EventGroup((newEvent) => ({
        notification: newEvent<{message: string;}>(),
    }))
}).root(actions)

export default events as typeof events & typeof actions;